// version.js — Application version and changelog
// Update this file when releasing new versions

export const VERSION = "1.1.0";
export const RELEASE_DATE = "2026-05-13";
export const BUILD_DATE = new Date().toISOString().split('T')[0];

export const CHANGELOG = [
  {
    version: "1.1.0",
    date: "2026-05-13",
    type: "major",
    highlights: [
      "OTP authentication for external users",
      "Role-based access control (admin/editor/readonly)",
      "User management interface",
      "AWS Secrets Manager integration",
      "Rate limiting and security enhancements"
    ],
    sections: {
      added: [
        "Dual authentication: Entra SSO + OTP",
        "One-time password system via email",
        "Rate limiting (3/hour for OTP requests)",
        "Role-based access control",
        "User management page (admin only)",
        "AWS Secrets Manager for SMTP credentials",
        "SQL injection protection",
        "Enhanced error handling"
      ],
      changed: [
        "Email-first login flow",
        "Role-aware navigation menu",
        "All API endpoints require authentication"
      ],
      fixed: [
        "CORS configuration for HTTPS",
        "SQL injection vulnerabilities",
        "SMTP error handling"
      ],
      security: [
        "OTP codes hashed in database",
        "Rate limiting on auth endpoints",
        "Field allowlists for dynamic queries",
        "Credentials moved to Secrets Manager"
      ]
    }
  },
  {
    version: "1.0.0",
    date: "2024-04-14",
    type: "initial",
    highlights: [
      "Initial release",
      "Azure AD authentication",
      "Usage reporting dashboard",
      "Customer and bundle management"
    ],
    sections: {
      added: [
        "Customer usage reporting",
        "Azure AD (Entra) authentication",
        "Multi-page dashboard",
        "CSV export functionality",
        "PostgreSQL backend",
        "FastAPI REST API",
        "React frontend"
      ]
    }
  }
];

export const getLatestVersion = () => CHANGELOG[0];
export const getVersionByNumber = (version) => CHANGELOG.find(v => v.version === version);
